import { ProductionInterface } from "./interface/production.interface";
import { create } from "zustand";

export const productionStore = create<ProductionInterface>((set) => ({
  statusEditProductionModal: "closed",
  setStatusEditProductionModal: (status) => set({ statusEditProductionModal: status }),
}));
